import { PUBLIC_URL } from "./index";

const _url = (url) => {
    return `${PUBLIC_URL}/${url}`
}

export default {
    _url
}

export {
    _url
}


// WEBPACK FOOTER //
// ./src/config/utils.js